export default __webpack_public_path__ + "static/media/average_breakfast@3x.f9bb81ef.png";